import React, { useEffect, useState } from "react";
import axios from "axios";

export default function SPXOptionsAdmin() {
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    date: "",
    type: "CALL",
    strike: "",
    expiry: "",
    buy_price: "",
    sell_price: "",
    stop_loss: "",
    status: "Active",
    notes: "",
  });

  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("access_token");

  const api = axios.create({
    baseURL: "/api",
    headers: token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {},
  });

  const loadCalls = async () => {
    try {
      const res = await api.get("/spx-options");
      setCalls(res.data || []);
    } catch (err) {
      console.error("Unable to load SPX calls", err);
    }
  };

  useEffect(() => {
    loadCalls();
  }, []);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const submitCall = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = {
        date: form.date,
        type: form.type,
        strike: Number(form.strike),
        expiry: form.expiry,
        buy_price: Number(form.buy_price),
        sell_price:
          form.sell_price === ""
            ? null
            : Number(form.sell_price),
        stop_loss:
          form.stop_loss === ""
            ? null
            : Number(form.stop_loss),
        status: form.status,
        notes: form.notes || null,
      };

      await api.post("/admin/spx-options", payload);

      setForm({
        date: "",
        type: "CALL",
        strike: "",
        expiry: "",
        buy_price: "",
        sell_price: "",
        stop_loss: "",
        status: "Active",
        notes: "",
      });

      await loadCalls();

      alert("SPX call added successfully");
    } catch (err) {
      console.error(err);
      alert(
        err?.response?.data?.detail ||
          "Unable to add SPX call"
      );
    } finally {
      setLoading(false);
    }
  };

  const deleteCall = async (id) => {
    if (!window.confirm("Delete this SPX call?")) {
      return;
    }

    try {
      await api.delete(`/admin/spx-options/${id}`);
      await loadCalls();
    } catch (err) {
      alert("Unable to delete call");
    }
  };

  return (
    <div className="space-y-8">

      <div className="rounded-2xl border border-white/10 bg-white/5 p-6">

        <h2 className="text-2xl font-bold text-white mb-6">
          Add SPX Option Call
        </h2>

        <form
          onSubmit={submitCall}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
        >

          <input
            type="date"
            name="date"
            value={form.date}
            onChange={handleChange}
            required
            className="bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white"
          />

          <select
            name="type"
            value={form.type}
            onChange={handleChange}
            className="bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white"
          >
            <option value="CALL">CALL</option>
            <option value="PUT">PUT</option>
          </select>

          <input
            type="number"
            step="0.01"
            name="strike"
            placeholder="Strike Price"
            value={form.strike}
            onChange={handleChange}
            required
            className="bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white"
          />

          <input
            type="date"
            name="expiry"
            value={form.expiry}
            onChange={handleChange}
            required
            className="bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white"
          />

          <input
            type="number"
            step="0.01"
            name="buy_price"
            placeholder="Buy Price"
            value={form.buy_price}
            onChange={handleChange}
            required
            className="bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white"
          />

          <input
            type="number"
            step="0.01"
            name="sell_price"
            placeholder="Sell Price"
            value={form.sell_price}
            onChange={handleChange}
            className="bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white"
          />

          <input
            type="number"
            step="0.01"
            name="stop_loss"
            placeholder="Stop Loss"
            value={form.stop_loss}
            onChange={handleChange}
            className="bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white"
          />

          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            className="bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white"
          >
            <option value="Active">Active</option>
            <option value="Closed">Closed</option>
          </select>

          <input
            type="text"
            name="notes"
            placeholder="Notes"
            value={form.notes}
            onChange={handleChange}
            className="bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-white"
          />

          <button
            type="submit"
            disabled={loading}
            className="rounded-xl px-5 py-3 font-bold bg-lime-400 text-black"
          >
            {loading ? "Adding..." : "Add SPX Call"}
          </button>

        </form>
      </div>

      <div className="rounded-2xl border border-white/10 overflow-hidden">

        <div className="p-5 border-b border-white/10">
          <h2 className="text-xl font-bold text-white">
            Existing SPX Calls
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left">

            <thead className="bg-white/5">
              <tr>
                <th className="p-4">Date</th>
                <th className="p-4">Type</th>
                <th className="p-4">Strike</th>
                <th className="p-4">Buy</th>
                <th className="p-4">Sell</th>
                <th className="p-4">Stop</th>
                <th className="p-4">Status</th>
                <th className="p-4">Action</th>
              </tr>
            </thead>

            <tbody>
              {calls.map((call) => (
                <tr
                  key={call.id}
                  className="border-t border-white/10"
                >
                  <td className="p-4">{call.date}</td>
                  <td className="p-4">{call.type}</td>
                  <td className="p-4">{call.strike}</td>
                  <td className="p-4">${call.buy_price}</td>
                  <td className="p-4">
                    {call.sell_price
                      ? `$${call.sell_price}`
                      : "Open"}
                  </td>
                  <td className="p-4">
                    {call.stop_loss
                      ? `$${call.stop_loss}`
                      : "-"}
                  </td>
                  <td className="p-4">{call.status}</td>

                  <td className="p-4">
                    <button
                      onClick={() =>
                        deleteCall(call.id)
                      }
                      className="text-red-400"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}

              {calls.length === 0 && (
                <tr>
                  <td
                    colSpan="8"
                    className="p-8 text-center text-gray-400"
                  >
                    No SPX calls added yet.
                  </td>
                </tr>
              )}

            </tbody>
          </table>
        </div>

      </div>

    </div>
  );
}

